import { AfterContentInit, AfterViewInit, Component, Input, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { BsModalService } from "ngx-bootstrap/modal";
import { firstValueFrom } from "rxjs";
import { VolunteerTaskViewRecord } from "../models/volunteer-task-record";
import { VolunteerTaskPointRecord, VolunteerTaskPointViewRecord } from "../models";

type StatusSource = VolunteerTaskViewRecord | VolunteerTaskPointRecord | VolunteerTaskPointViewRecord;

@Component({
    styles: [ 'option { background-color: white; }' ],
    template: `
        <form class="p-0 m-0" #statusForm="ngForm">
            <div>
                <div class="modal-header light-blue-header white">
                    <div class="modal-title">
                        <h5>
                            Assign Status
                        </h5>
                    </div>
                    <button
                            type="button"
                            class="close pull-right"
                            aria-label="Close"
                            (click)="onCancel()"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div *ngIf="contextMsg" class="mb-2 text-secondary">{{contextMsg}}</div>
                    <select name="statusSelect"
                            required id="status-select" class="status-label"
                            [ngClass]="chosenStatus|taskStatusCss"
                            *ngIf="chosenStatus!=null" [value]="chosenStatus" (change)="bLoading=false;changeSelected($event.target)">
                        <option class="status-not-started-text" value="1">Not Started</option>
                        <option class="status-in-progress-text" value="2">In Progress</option>
                        <option class="status-field-complete-text" value="3">Complete</option>
                        <option class="status-review-complete-text" value="4">Field Complete</option>
                        <option class="status-approved-text" value="5">Review Complete</option>
                        <option class="status-not-using-text" value="6">Not Using</option>
                        <option class="status-archived-text" value="7">Archived</option>
                    </select>
                </div>
                <div class="modal-footer small">
                    <button
                            [disabled]="bLoading"
                            (click)="onSave()"
                            class="btn btn-primary"
                    >
                        Save
                    </button>
                    <button (click)="onCancel()" class="btn btn-secondary">Cancel</button>
                </div>
            </div>
        </form>
    `,
})
export class VolunteerStatusChooserModal implements AfterViewInit {
    @Input() statusSource: StatusSource;

    @Input() chosenStatus?: number = undefined;

    @Input() modalService!: BsModalService;

    @Input() contextMsg?: string;

    @ViewChild("statusForm") statusForm: NgForm;

    static async chooseStatus(
        statusSource: StatusSource,
        modalService: BsModalService,
        contextMsg?: string
    ) {
        const initialState = {
            statusSource,
            modalService,
            contextMsg,
        };
        const modalRef = modalService.show(VolunteerStatusChooserModal, {
            initialState,
            ignoreBackdropClick: true,
            id: "VolunteerStatusModal",
            
        });
        await firstValueFrom(modalRef.onHidden);
        return modalRef.content.chosenStatus;
    }

    bLoading = false;
    errorMsg = "";

    constructor() {
    }

    ngAfterViewInit(): void {
        const pointId = (this.statusSource as VolunteerTaskPointViewRecord)?.pointId;
        if ( !this.contextMsg && pointId ) {
            this.contextMsg = "Point: " + pointId;
        }
        this.init();
    }

    init = async () => {
        this.chosenStatus = this.statusSource.status
        this.statusForm?.form?.markAsPristine();
    };

    onCancel() {
        this.chosenStatus = undefined;
        this.modalService.hide();
    }

    onSave() {
        this.modalService.hide();
    }

    changeSelected(target: any) {
        this.chosenStatus=target.value;
    }
}
